import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useUser } from "./UserContext";
import { useAuth } from "../contexts/AuthContext";
import NotificationBell from '../components/NotificationComponents/NotificationBell';
import "./Navbar.css";

const Navbar = () => {
  const { user, logout } = useUser();
  const { token, userRole, logout: authLogout } = useAuth();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  if (!token && location.pathname === '/') {
    return (
      <nav className="navbar">
        <div className="navbar-container">
          <div className="navbar-logo">
            <Link to="/">
              <span className="logo-text">Tech<span className="highlight">Service</span>Market</span>
            </Link>
          </div>
          <div className="auth-buttons">
            <Link to="/login" className="nav-auth-button">Login</Link>
            <Link to="/register" className="nav-auth-button register">Register</Link>
          </div>
        </div>
      </nav>
    );
  }

  if (!token && (
    location.pathname === '/login' || 
    location.pathname === '/register' ||
    location.pathname === '/university/login' ||
    location.pathname === '/university/register' ||
    location.pathname === '/recruiter/login' ||
    location.pathname === '/recruiter/register'
  )) {
    return null;
  }

  const handleLogout = () => {
    logout();
    authLogout();
    navigate("/login");
  };

  const isActive = (path) => {
    return location.pathname.startsWith(path) ? "active" : "";
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const renderUserLinks = () => (
    <>
      <li className={isActive("/dashboard")}>
        <Link to="/dashboard">Dashboard</Link>
      </li>
      <li className={isActive("/dashboard/events")}>
        <Link to="/dashboard/events">Events</Link>
      </li>
      <li className={isActive("/profile/applicationList")}>
        <Link to="/profile/applicationList">Applications</Link>
      </li>
      <li className={isActive("/discussions")}>
        <Link to="/discussions">Discussions</Link>
      </li>
      <li className={isActive("/profile/messages")}>
        <Link to="/profile/messages">Messages</Link>
      </li>
      <li className={isActive("/news")}>
        <Link to="/news">News</Link>
      </li>
    </>
  );

  const renderRecruiterLinks = () => (
    <>
      <li className={isActive("/recruiter/dashboard")}>
        <Link to="/recruiter/dashboard">Dashboard</Link>
      </li>
      <li className={isActive("/recruiter/jobs/new")}>
        <Link to="/recruiter/jobs/new">Post Job</Link>
      </li>
      <li className={isActive("/recruiter/events")}>
        <Link to="/recruiter/events">My Events</Link>
      </li>
      <li className={isActive("/recruiter/events/new")}>
        <Link to="/recruiter/events/new">Create Event</Link>
      </li>
      <li className={isActive("/recruiter/messages")}>
        <Link to="/recruiter/messages">Messages</Link>
      </li>
    </>
  );

  const renderUniversityLinks = () => (
    <>
      <li className={isActive("/university/dashboard")}>
        <Link to="/university/dashboard">Dashboard</Link>
      </li>
      <li className={isActive("/university/jobs/new")}>
        <Link to="/university/jobs/new">Post Job</Link>
      </li>
      <li className={isActive("/university/jobs/reposted")}>
        <Link to="/university/jobs/reposted">Posted Jobs</Link>
      </li>
      <li className={isActive("/university/events")}>
        <Link to="/university/events">My Events</Link>
      </li>
      <li className={isActive("/university/events/new")}>
        <Link to="/university/events/new">Create Event</Link>
      </li>
      <li className={isActive("/university/students")}>
        <Link to="/university/students">Students</Link>
      </li>
      <li className={isActive("/university/messages")}>
        <Link to="/university/messages">Messages</Link>
      </li>
    </>
  );

  if (!user || !token) {
    return null;
  }

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="navbar-logo">
          {userRole === 'user' && (
            <Link to="/dashboard">
              <span className="logo-text">Tech<span className="highlight">Service</span>Market</span>
            </Link>
          )}
          {userRole === 'recruiter' && (
            <Link to="/recruiter/dashboard">
              <span className="logo-text">Tech<span className="highlight">Service</span>Market</span>
            </Link>
          )}
          {userRole === 'universitypartner' && (
            <Link to="/university/dashboard">
              <span className="logo-text">Tech<span className="highlight">Service</span>Market</span>
            </Link>
          )}
        </div>

        <div className="hamburger" onClick={toggleMenu}>
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </div>

        <div className={`navbar-content ${isMenuOpen ? 'active' : ''}`}>
          <ul className="navbar-links">
            {userRole === 'user' && renderUserLinks()}
            {userRole === 'recruiter' && renderRecruiterLinks()}
            {userRole === 'universitypartner' && renderUniversityLinks()}
          </ul>

          <div className="navbar-user">
            <NotificationBell />
            <Link to="/profile">
              <div className="user-info">
                <span className="user-name">{user.firstName || user.username || "User"}</span>
                <span className="user-role">{userRole || "User"}</span>
              </div>
            </Link>
            <button onClick={handleLogout} className="logout-button">
              <i className="fas fa-sign-out-alt"></i> Logout
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
